import { createAction } from 'typesafe-actions';
import { ACTIONS, RoundWinner } from './types';

export const setRoundWinnersDataAction = createAction(ACTIONS.SET_ROUND_WINNERS_DATA)<{
  winners: RoundWinner[];
}>();

export const resetRoundWinnersDataAction = createAction(ACTIONS.RESET_ROUND_WINNERS_DATA)();
